import React, { createRef } from "react";
import PropTypes from "prop-types";
import "./style.less";
import axios from 'axios/dist/axios.min.js'
import utils from "../../utils/utils";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Swiper from 'swiper/swiper-bundle.min.js'
import 'swiper/swiper.less'
import 'swiper/components/pagination/pagination.less'

const mainFloorBgs = [
  {
    blockBigBg: 'https://static.shihuocdn.cn/admin/files/20211031/1d8858fe6c65b99895c8242173cdfc6c.png',
    blockSmallBg: 'https://static.shihuocdn.cn/admin/files/20211101/cd03087fdf18e347806fa68d18d619ed.png',
    blockBg: 'https://static.shihuocdn.cn/admin/files/20211031/eb9cfe3ad6674dcabcff6fe17c4c4116.png',
    collectionBg: 'https://static.shihuocdn.cn/admin/files/20211031/20b34e10ae82b654e697065dd0e4093d.png',
    tagBg: '#e8387f'
  },
  {
    blockBigBg: 'https://static.shihuocdn.cn/admin/files/20211031/bef333f62b9e72570342fe8210fad28b.png',
    blockSmallBg: 'https://static.shihuocdn.cn/admin/files/20211101/8089f0e79982596b3629c2483d38fcfe.png',
    blockBg: 'https://static.shihuocdn.cn/admin/files/20211031/357723701640d2b8535a125f0a457c9b.png',
    collectionBg: 'https://static.shihuocdn.cn/admin/files/20211031/f5d2d3688e65ea8e9c06d0cf240ae5ea.png',
    tagBg: '#ee8600'
  },
  {
    blockBigBg: 'https://static.shihuocdn.cn/admin/files/20211031/e76b0c19a6ae2194ab85541d81ad3c56.png',
    blockSmallBg: 'https://static.shihuocdn.cn/admin/files/20211101/5dd5d6a7302873ae6cf98f19e70cc714.png',
    blockBg: 'https://static.shihuocdn.cn/admin/files/20211031/444aff6be31adee806c2cab2908d0ce6.png',
    collectionBg: 'https://static.shihuocdn.cn/admin/files/20211031/b8250e416f8b4978e4ff6477f10a0161.png',
    tagBg: '#7450ff'
  }
]

const oldMainFloorBgs = [
  {
    blockBigBg: 'https://static.shihuocdn.cn/admin/files/20211103/b4722bc34c1e9293791a191c152a46b1.png',
  },
  {
    blockBigBg: 'https://static.shihuocdn.cn/admin/files/20211103/d29151a6de44cdfab0388f3408a62123.png',
  },
  {
    blockBigBg: 'https://static.shihuocdn.cn/admin/files/20211103/be86c273ecedd8fffaed313c92da305f.png',
  }
]

const fenFloorBgs = [
  {
    blockBg: 'https://static.shihuocdn.cn/admin/files/20211031/fa8cdef3fc98c2dc5f9aa6cf335069a5.png',
    collectionBg: 'https://static.shihuocdn.cn/admin/files/20211031/9523ae12edc01dc2bf36bfe24d715b4f.png',
    tagBg: ''
  },
  {
    blockBg: 'https://static.shihuocdn.cn/admin/files/20211031/982ccbb6d50524f3ec0e25be1f72a61a.png',
    collectionBg: 'https://static.shihuocdn.cn/admin/files/20211031/7d6c2a20d6ad42d5f0c770212f1f4d4e.png',
    tagBg: ''
  },
  {
    blockBg: 'https://static.shihuocdn.cn/admin/files/20211031/ef155578d362e3e625fb596f4f4eff77.png',
    collectionBg: 'https://static.shihuocdn.cn/admin/files/20211031/b2dce2cbde31e03e1bb502c09d56e0b1.png',
    tagBg: ''
  },
  {
    blockBg: 'https://static.shihuocdn.cn/admin/files/20211031/0534882c972c450250cd98e2001dc141.png',
    collectionBg: 'https://static.shihuocdn.cn/admin/files/20211031/57693d530a826816686fb02bcf528323.png',
    tagBg: ''
  },
  {
    blockBg: 'https://static.shihuocdn.cn/admin/files/20211031/c42fbcd7755920dc443f91cbf5ab840b.png',
    collectionBg: 'https://static.shihuocdn.cn/admin/files/20211031/db3e4a04ed4c53f474629624ad3268de.png',
    tagBg: ''
  }
]

class PipelineFloor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabList: [],
      tabIndex: 0,
      floorList: [],
      navFixed: false,
      venue: utils.getQueryString('venue'),
      venueGoodsId: utils.getParams('venueGoodsId') || '',
      venueStyleId: utils.getParams('venueStyleId') || '',
    };
    this.lotteryInterval = {}
    this.adSwiper = null
    this.isSetLotterySwiper = false;
  }

  componentDidMount() {
    this.getData()
  }

  componentWillUnmount() {
    Object.keys(this.lotteryInterval).forEach(key => {
      this.lotteryInterval[key] && clearInterval(this.lotteryInterval[key])
    })
  }

  getData = () => {
    let { list = [] } = this.props.config
    list = list.filter((item) => (item.type == '普通楼层' && item.goodsConfig.type == '商品id')).concat(list.filter((item) => (item.type != '普通楼层' || item.goodsConfig.type != '商品id')))

    const cateList = []
    list.map((item, index) => {
      if (item.cateIds && item.type == '普通楼层' && item.goodsConfig.type == '二级类目id') {
        cateList.push({
          "key": index + "",
          "cate": item.cateIds
        })
      }
    })

    axios({
      baseURL: process.env.NODE_ENV == 'development' ? '' : 'https://sh-gateway.shihuo.cn',
      url: '/v4/services/sh-venueapi/common/tabOrder?access_token=znSnA7pxO35wtPBaur',
      method: 'post',
      withCredentials: true,
      data: {
        cateList,
        scene: 'ACTIVITY_618_TAB_REC',
        from: window.location.href
      },
    }).then(res => {
      res = res.data
      const copyList = JSON.parse(JSON.stringify(list))
      let floorList = list
      if (res.status == 0) {
        const { orderCateList = [] } = res.data || {}
        let mapIndex = 0
        orderCateList.forEach(key => {
          floorList.forEach((item, index) => {
            if (key == index) {
              for (let i = mapIndex; i < copyList.length; i++) {
                if (copyList[i].cateIds && copyList[i].goodsConfig.type == '二级类目id' && copyList[i].type == '普通楼层') {
                  floorList[i] = copyList[+key]
                  mapIndex = i + 1
                  break
                }
              }
            }
          })
        })
      }

      const tabList = []
      const lastClickTabName = window.localStorage.getItem('last_click_tab_name') || ''
      window.localStorage.removeItem('last_click_tab_name')
      let lastClickTabIndex = -1
      floorList.forEach((item, floorIndex) => {
        // 指定会场置顶
        if (item.tabName == this.state.venue) {
          floorList.splice(floorIndex, 1);
          floorList.unshift(item);
        }
        item.showPage = 1;
        item.keywordsList = []
        const collectionList = item.collectionList
        const collectionArrList = []
        const avg = Math.ceil(collectionList.length / 2)
        for (let i = 0; i < 3; i++) {
          const arr = []
          for (let j = 0; j < avg; j++) {
            const collection = collectionList[j * 2 + i]
            if (collection) {
              arr.push(collection)
            }
          }
          if (arr.length > 0) {
            collectionArrList.push(arr)
          }
        }
        item.collectionList = collectionArrList

        item.collectionList.forEach((item, index) => {
          this.setLotterySwiper(floorIndex, index)
        })

        if (item.type == '普通楼层') {
          tabList.push(item.tabName)
        } else if (item.type == '包表配楼层' && !tabList.some(tabName => tabName == item.tabName)) {
          tabList.push(item.tabName)
        }

        if (window.squareType == '分会场' && lastClickTabName == item.name && lastClickTabIndex == -1) {
          lastClickTabIndex = floorIndex
        }

        const goodsConfig = item.goodsConfig
        goodsConfig.goodsList = []
      })

      if (window.squareType == '分会场' && lastClickTabIndex > 0) {
        const floor = floorList.splice(lastClickTabIndex, 1)
        floorList = [floor].concat(floorList)
      }

      this.state.venue && tabList.forEach((tabItem, tabIndex) => {
        // 指定会场置顶
        if (tabItem == this.state.venue) {
          tabList.splice(tabIndex, 1);
          tabList.unshift(tabItem);
        }
      });

      this.setState({
        tabList,
        floorList
      }, () => {
        floorList.forEach((floor, floorIndex) => {
          this.getGoodsList(floorIndex, 1)
          if (window.squareType == '主会场') {
            this.getKeywordsList(floorIndex)
          }
        })
        setTimeout(() => {
          const { ztAdList = [] } = this.props.config;
          if (Swiper && ztAdList.length > 0) {
            this.adSwiper = new Swiper('.zt-content', {
              autoplay: ztAdList.length > 1 ? { disableOnInteraction: false } : false,
              speed: 500,
              loop: ztAdList.length > 1 ? true : false,
            });
          }
        }, 1000);
      })
    })
  }

  getKeywordsList = (floorIndex) => {
    const { floorList } = this.state
    const floor = floorList[floorIndex]
    if (!floor.breakCateId) {
      return
    }
    axios({
      baseURL: process.env.NODE_ENV == 'development' ? '' : 'https://sh-gateway.shihuo.cn',
      url: '/v4/services/sh-venueapi/common/keywords?access_token=znSnA7pxO35wtPBaur',
      method: 'get',
      withCredentials: true,
      params: {
        master_cate_id: +floor.breakCateId
      },
    }).then(res => {
      res = res.data
      if (res.status == 0) {
        floor.keywordsList = res.data || []
      }
    })
  }

  getGoodsList = async (floorIndex, page) => {
    const isMain = window.squareType == '主会场'
    const squareStageType = window.squareStageType;
    const { floorList } = this.state
    const floor = floorList[floorIndex]
    const goodsConfig = floor.goodsConfig
    let goods_type = 0;
    switch (squareStageType) {
      case "预售":
        goods_type = 1
        break;
      case "预热":
        goods_type = 2
        break;
      case "正式":
        goods_type = 3
        break;
      case "全部商品":
        goods_type = 0
        break;
      default:
        break;
    }
    let res
    if (goodsConfig.type == '二级类目id') {
      res = await axios({
        baseURL: process.env.NODE_ENV == 'development' ? '' : 'https://sh-gateway.shihuo.cn',
        url: '/v4/services/sh-venueapi/common/goodsListByCate?access_token=znSnA7pxO35wtPBaur',
        method: 'post',
        withCredentials: true,
        data: {
          cate: floor.cateIds.split(','),
          page_size: 60,
          page_on: page,
          goods_type: goods_type,
          from: window.location.href,
          scene: 'ACTIVITY_618_GOODSLIST_REC',
          goods_from: 0
        },
      })
    } else {
      const itemList = goodsConfig.goodsIds ? goodsConfig.goodsIds.split(',') : goodsConfig.goodsList;
      const pref = goodsConfig.productType === "商品id" ? 'g' : 'p'
      const idList = itemList.map((item) => {
        const id = pref + (goodsConfig.goodsIds ? item : item.id)
        return id
      });
      res = await axios({
        baseURL: process.env.NODE_ENV == 'development' ? '' : 'https://sh-gateway.shihuo.cn',
        url: '/v4/services/sh-venueapi/common/goodsListByIds?access_token=znSnA7pxO35wtPBaur',
        method: "post",
        withCredentials: true,
        data: {
          goods_id: idList,
        },
      })
    }
    if (res.data.status === 0) {
      let goodsList = (res.data.data.goods_list || []).map(goods => {
        return {
          ...goods,
          image: goods.pic,
          title: goods.level == "g" ? goods.goodsName : (goods.goodsName + ' ' + goods.styleName),
          original_price: goods.officialPrice,
          url: goods.detailHref,
          recommend: goods.tag || '',
        }
      })

      // 指定会场里的指定商品置顶显示
      if (this.state.venue && this.state.venue == floor.tabName && this.state.venueGoodsId) {
        goodsList.forEach((goodsItem, goodsIndex) => {
          if (this.state.venue && this.state.venueGoodsId == goodsItem.goodsId && (goodsItem.styleId && this.state.venueStyleId == goodsItem.styleId)) {
            goodsList.splice(goodsIndex, 1);
            goodsList.unshift(goodsItem)
          }
        }) 
      }

      if (!(floor.type == '包表配楼层')) {
        const adList = goodsConfig.adList || []
        adList.forEach((ad) => {
          const { startTime, endTime, img, position } = ad
          let pos = +position.trim() - 1
          const now = new Date().getTime()
          if (startTime && endTime && img && pos >= 0 && now >= new Date(startTime).getTime() && now <= new Date(endTime).getTime()) {
            ad.type = 'ad'
            goodsList = goodsList.slice(0, pos).concat([ad]).concat(goodsList.slice(pos, goodsList.length))        
          }
        })
      }

      const pageSize = Math.ceil((goodsList.length - 3) / 24) + 1;
      floor.pageSize = pageSize >= 3 ? 3 : pageSize;
      goodsConfig.goodsList = goodsList
      // const adConfig = goodsConfig.adConfig
      // if (adConfig.img && goodsList.length >= 3) {
      //   adConfig.type = 'ad'
      //   goodsConfig.goodsList = goodsList.slice(0, 3).concat([adConfig]).concat(goodsList.slice(3, goodsList.length))
      // }

      this.setState({
        floorList,
      }, () => {
        this.handleXScroll(floorIndex, true)
      });
    }
  }

  handleXScroll = (floorIndex, init) => {
    const isMain = typeof window !== "undefined" && window.squareType == '主会场'
    setTimeout(() => {
      const goodsVisible = []
      const tagVisible = []
      const from = window.squareType == '主会场' ? '618_main_square' : window.squareName
      const goodsScrollEl = document.querySelector(`.goods-block-${floorIndex}`)
      const { floorList } = this.state
      const floor = floorList[floorIndex]
      const goodsNumCell = floor.goodsConfig.goodsList.length >= 20 && isMain && floorIndex == 0 ? 2 : 1
      if (goodsScrollEl) {
        const block = window.squareType == '主会场' ? `${floor.type == '普通楼层' ? 'headstorey' : 'middlestorey'}_goodslist` : 'storey_goods'
        const subs = goodsScrollEl.querySelectorAll('.goods-arr-item') || []
        const goodsArr = floor.goodsArr || []
        // const goodsNumCell = floor.collectionList.length >= 3 ? 1 : 2
        const listener = () => {
          let exposure_str = ``
          for (let i = 0; i < subs.length; i++) {
            const el = subs[i];
            const visible = goodsScrollEl && el && el.getBoundingClientRect().left > 0 && el.getBoundingClientRect().left < goodsScrollEl.clientWidth
            if (!goodsVisible[i] && visible) {
              const action_time = new Date().valueOf()
              const arr = goodsArr[i]
              if (arr) {
                arr.forEach((item, index) => {
                  if (item.type == 'ad') {
                    exposure_str += (exposure_str ? '#' : '') + `.za..${from}.goods_list_ad....${i * goodsNumCell + index}.${floor.breakCateId}.....${floor.title}.${floorIndex}.${goodsNumCell}@${action_time}`
                  } else {
                    exposure_str += (exposure_str ? '#' : '') + `.za.goodsDetail.${from}.${block}..${item.goodsId}.${item.styleId}.${i * goodsNumCell + index}.${floor.breakCateId}.....${floor.title}.${floorIndex}.${goodsNumCell}@${action_time}`
                  }
                })
              }
            }
            goodsVisible[i] = visible
          }
          if (exposure_str) {

          }
        }
        if (init) {
          goodsScrollEl.addEventListener('scroll', listener)
        } else {
          listener()
        }
      }
      const tagScrollEl = document.querySelector(`.footer-${floorIndex}`)
      if (tagScrollEl) {
        const subs = tagScrollEl.querySelectorAll('.tag-item') || []
        const listener = () => {
          for (let i = 0; i < subs.length; i++) {
            const el = subs[i];
            const item = floor.keywordsList[i]
            const visible = tagScrollEl && el && el.getBoundingClientRect().left > 0 && el.getBoundingClientRect().left < tagScrollEl.clientWidth
            if (!tagVisible[i] && visible && item) {
              const action_time = new Date().valueOf()
              let exposure_str = `.za.RNProgram.${from}.headstorey_dynamicLabels....${i}.${floor.breakCateId}....${item}.${floor.title}.${floorIndex}.${goodsNumCell}@${action_time}`
              if (exposure_str) {

              }
            }
            tagVisible[i] = visible
          }
        }
        if (init) {
          tagScrollEl.addEventListener('scroll', listener)
        } else {
          listener()
        }
      }
    }, 1000)
  }

  handleBodyScroll = () => {
    if (!window.document.querySelector('.floor-tab')) {
      return
    }
    const tabBarHeight = window.document.querySelector('.floor-tab-list').clientHeight

    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
    const navOffsetTop = window.document.querySelector('.floor-tab').offsetTop - this.props.navigationBarHeight;

    const navMarginTop = 0;
    const navFixed = scrollHeight - navOffsetTop >= navMarginTop && scrollHeight < (window.document.querySelector('.floor-wrapper').clientHeight + navOffsetTop - window.document.querySelector('.more-item').clientHeight)
    if (navFixed != this.state.navFixed) {
      this.setState({
        navFixed
      });
    }

    const list = window.document.querySelectorAll('.floor-item') || [];
    const stopIndex = window.squareType == '主会场' ? list.length - 1 : list.length - 1
    for (let i = 0; i < list.length; i += 1) {
      const item = list[i]
      if (item && scrollHeight >= item.offsetTop - tabBarHeight - this.props.navigationBarHeight) {
        if (i == list.length - 1 || scrollHeight < list[i + 1].offsetTop - tabBarHeight - this.props.navigationBarHeight) {
          const tabIndex =  i > stopIndex ? stopIndex : i
          if (tabIndex != this.state.tabIndex) {
            this.setState({
              tabIndex
            }, () => {
              if (navFixed) {
                const tabItemEls = window.document.querySelectorAll('.floor-tab-item')
                if (tabItemEls && tabItemEls[tabIndex]) {
                  tabItemEls[tabIndex].scrollIntoView()
                }  
              }
            })
          }
          break
        }
      }
    }
  }

  handleTabClick = (index) => {
    const list = window.document.querySelectorAll('.floor-item') || [];
    const tabBarHeight = window.document.querySelector('.floor-tab-list').clientHeight
    if (list[index]) {
      document.documentElement.scrollTop = list[index].offsetTop - tabBarHeight - this.props.navigationBarHeight + (utils.isAndroid() ? 3 : 0)
      document.body.scrollTop = list[index].offsetTop - tabBarHeight - this.props.navigationBarHeight + (utils.isAndroid() ? 3 : 0)
    }
    const tabItemEls = window.document.querySelectorAll('.floor-tab-item')
    if (tabItemEls && tabItemEls[index]) {
      if (window.document.querySelector('.floor-tab-list')) {
        window.document.querySelector('.floor-tab-list').scrollLeft = tabItemEls[index].offsetLeft - window.innerWidth / 2 + tabItemEls[index].clientWidth / 2
      }
      // tabItemEls[index].scrollIntoView()
    }  
    const { floorList, tabList } = this.state
    // utils.handleItemClick(this.props.routeParams, '', 'storey_tab', { from_sort: index, tabChName: tabList[index], child_category_id: floorList[index].cateIds })
    const options = {
      sort: index,
      name: tabList[index],
      tabChName: tabList[index],
      child_category_id: floorList[index].cateIds
    };
    utils.uploadTrack(this.props, options, {
      bizExtra: {
        model_block: 'tab',
        tabChName:  tabList[index],
      }
    });
    // utils.jumpToUrl(this.props.routeParams,item.url,item.url,options,item.id,this.props);
  }

  setLotterySwiper(floorIndex, index) {
    if (this.isSetLotterySwiper) {
      return;
    }
    this.isSetLotterySwiper = true;
    setTimeout(() => {
      const collectionAll = document.querySelectorAll('.collection-arr');
      for (let elIndex = 0; elIndex < collectionAll.length; elIndex++) {
        const elClass = collectionAll[elIndex].getAttribute('class');
        const swiperTarget = elClass.split(" ")[2]
        if (index > 1) {
          break;
        }
        new Swiper(`.${swiperTarget}`, {
          direction: 'vertical',
          slidesPerView: 1,
          simulateTouch: false,
          spaceBetween: 0,
          centeredSlides: false,
          autoplay: {
            delay: 3000,
            disableOnInteraction : false
          },
          loop: true
        })
      }
    }, 2000)
  }

  setLottery(floorIndex, index) {
    setTimeout(() => {
      const { floorList } = this.state
      const list = floorList[floorIndex].collectionList
      clearInterval(this.lotteryInterval[`.interval-${floorIndex}-${index}`])
      const el = document.querySelector(`.lottery-all-${floorIndex}-${index}`)
      if (list && list.length > 0 && list[index].length > 1 && el) {
        list[index] = list[index].concat(list[index].slice(0, 1))
        this.setState({
          list
        })
        let pos = 0
        let itemHeight = 0
        if (itemHeight == 0 && document.querySelectorAll(`.lottery-item-${index}`).length > 0) {
          itemHeight = document.querySelectorAll(`.lottery-item-${index}`)[0].clientHeight
        }

        this.lotteryInterval[`.interval-${floorIndex}-${index}`] = setInterval(() => {
          pos++
          el.style.transform = `translate3d(0,${-itemHeight * pos}px,0)`
          el.style.transitionDuration = `500ms`
          if (pos == list[index].length - 1) {
            setTimeout(() => {
              pos = 0
              el.style.transform = `translate3d(0,0,0)`
              el.style.transitionDuration = `0ms`
            }, 500)
          }
        }, 3500)
      }
    }, (floorIndex + 1) * 1600)
  }

  render() {
    const customAttributes = {
      "data-component-id": this.props["data-component-id"],
      "data-component-name": this.props["data-component-name"],
    };

    const { baseConfig, moreInfo, ztAdList = [] } = this.props.config;
    const { tabList, tabIndex, floorList, navFixed } = this.state

    if (tabList.length == 0) {
      return null
    }

    const isMain = window.squareType == '主会场'

    const isHotStyle = window.isHotStyle == '是'

    const moreFloorBg = isHotStyle ? 'https://static.shihuocdn.cn/admin/imgs/20211102/5d2c145ce0747c1baa8e9c8ec1c1c7c3_702x560.png' : moreInfo.bgImg

    return (
      <div
        className="floor-wrapper"
        {...this.props['customAttributes']}
        style={{
          marginTop: `${baseConfig.moduleMarginTop}px`,
          // marginLeft: `${baseConfig.moduleMarginHorizon}px`,
          // marginRight: `${baseConfig.moduleMarginHorizon}px`,
          // background: `url(${baseConfig.bgImg}) center no-repeat`
        }}
      >
        <div className="floor-tab">
          {/* <img className="floor-bg" src="https://static.shihuocdn.cn/admin/files/20211014/4baa1307c0dfb91a06f6a0a219ef5a93.png"/> */}
          <div
            className="floor-tab-list"
            style={{
              position: navFixed ? 'fixed' : 'relative',
              top: navFixed ? this.props.navigationBarHeight : 0,
              zIndex: navFixed ? 10 : 0,
              background: window.backgroundColor
            }}
          >
            {
              tabList.map((name, index) => {
                return (
                  <div onClick={this.handleTabClick.bind(this, index)} className={`floor-tab-item tab-item ${tabIndex == index ? 'active' : ''} ${isMain ? '' : 'fen'}`} key={index}>{name}</div>
                )
              })
            }
            <div className="empty-item"></div>
          </div>
        </div>
        <div className="floor-list">
          {
            floorList.map((floor, floorIndex) => {
              // const goodsNumCell = floor.collectionList.length >= 3 || floor.type != '普通楼层' ? 1 : 2
              const goodsList = floor.goodsConfig.goodsList
              const goodsNumCell = goodsList.length >= 20 && isMain && floorIndex == 0 ? 1 : 1

              let heightClassName = ''
              let isXxsFloor = false
              if (goodsNumCell == 2) {
                heightClassName = 'height-xl'
              } else if (floor.type == '包表配楼层') {
                heightClassName = 'height-xxs'
                isXxsFloor = true
              } else if (floor.keywordsList.length == 0 && floor.collectionList.length > 0) {
                heightClassName = 'height-m'
              } else if (floor.keywordsList.length > 0 && floor.collectionList.length == 0) {
                heightClassName = 'height-s'
              } else if (floor.keywordsList.length == 0 && floor.collectionList.length == 0) {
                heightClassName = 'height-xs'
              }

              const totalCell = Math.ceil(floor.goodsConfig.goodsList.length / goodsNumCell)
              let goodsArr = []
              if (!isXxsFloor) {
                for (let i = 0; i < totalCell; i++) {
                  const arr = []
                  for (let j = 0; j < goodsNumCell; j++) {
                    const idx = i * goodsNumCell + j
                    if (idx < goodsList.length) {
                      arr.push(goodsList[idx])
                    }
                  }
                  if (arr.length == goodsNumCell) {
                    goodsArr.push(arr)
                  }
                }
              }

              if (floor.showPage <= 1) {
                goodsArr = goodsArr.slice(0, 3);
              } else if (floor.showPage >= 2 && floor.showPage <= 3) {
                goodsArr = goodsArr.slice(0, (floor.showPage - 1) * 24);
              } else {
                goodsArr = goodsArr.slice(0, 2 * 24);
              }

              floor.goodsArr = goodsArr;

              let ztAdView = null
              if (floorIndex == 0 && ztAdList.length > 0) {
                ztAdView = (
                  <div
                    key={`zt-ad-${floorIndex}`} className="zt-ad"
                    onClick={() => {
                      if (!this.adSwiper) {
                        return
                      }
                      const ztIndex = this.adSwiper.realIndex
                      const ztAd = ztAdList[ztIndex]
                      if (ztAd) {
                        // utils.handleItemClick(this.props.routeParams, ztAd.link, 'middle_ad', { from_sort: ztIndex })
                        const options = {
                          sort: ztIndex
                        }
                        utils.jumpToUrl(this.props.routeParams,ztAd.link,ztAd.link,options,-1, this.props, false, {bizExtra: {model_block: 'advertising', floor_name: floor.tabName}});
                      }
                    }}
                  >
                    <div className="zt-content swiper-container">
                      <div className="swiper-wrapper">
                        {
                          ztAdList.map((ztAd, ztIndex) => {
                            return (
                              <img
                                key={ztIndex}
                                alt=""
                                className="cont swiper-slide"
                                src={utils.formatImgUrl(ztAd.img, this.props.webpSupport)}
                              />
                            )
                          })
                        }
                      </div>
                    </div>
                  </div>
                )
              }

              const floorItemBgSmall = floor.bgImgSmall
              const floorItemBgMiddle = floor.bgImgMiddle
              const floorItemBgLarge = floor.bgImg

              let floorItemBg = '';
              if (floor.showPage == 1) {
                floorItemBg = floor.bgImgSmall
              } else if (floor.showPage == 2) {
                floorItemBg = floor.bgImgMiddle
              } else {
                floorItemBg = floor.bgImg
              }

              let collectionBg = floor.bgCollectionImg
              let tagColor = floor.tagColor
              if (isMain && isHotStyle) {
                if (floor.title.indexOf('美妆') != -1 || floor.title.indexOf('配饰') != -1) {
                  floorItemBg = goodsNumCell == 2 ? mainFloorBgs[0].blockBigBg : (floor.type == '包表配楼层' ? mainFloorBgs[0].blockSmallBg : mainFloorBgs[0].blockBg)
                  collectionBg = mainFloorBgs[0].collectionBg
                  tagColor = mainFloorBgs[0].tagBg
                } else if (floor.title.indexOf('服') != -1 || floor.title.indexOf('箱包') != -1) {
                  floorItemBg = goodsNumCell == 2 ? mainFloorBgs[1].blockBigBg : (floor.type == '包表配楼层' ? mainFloorBgs[1].blockSmallBg : mainFloorBgs[1].blockBg)
                  collectionBg = mainFloorBgs[1].collectionBg
                  tagColor = mainFloorBgs[1].tagBg
                } else {
                  floorItemBg = goodsNumCell == 2 ? mainFloorBgs[2].blockBigBg : (floor.type == '包表配楼层' ? mainFloorBgs[2].blockSmallBg : mainFloorBgs[2].blockBg)
                  collectionBg = mainFloorBgs[2].collectionBg
                  tagColor = mainFloorBgs[2].tagBg
                }
              } else if (!isMain && isHotStyle) {
                if (window.document.title.indexOf('鞋') != -1) {
                  floorItemBg = fenFloorBgs[0].blockBg
                  collectionBg = fenFloorBgs[0].collectionBg
                } else if (window.document.title.indexOf('服') != -1) {
                  floorItemBg = fenFloorBgs[1].blockBg
                  collectionBg = fenFloorBgs[1].collectionBg
                } else if (window.document.title.indexOf('数码') != -1) {
                  floorItemBg = fenFloorBgs[2].blockBg
                  collectionBg = fenFloorBgs[2].collectionBg
                } else if (window.document.title.indexOf('美妆') != -1) {
                  floorItemBg = fenFloorBgs[3].blockBg
                  collectionBg = fenFloorBgs[3].collectionBg
                } else {
                  floorItemBg = fenFloorBgs[4].blockBg
                  collectionBg = fenFloorBgs[4].collectionBg
                }
              } else if (isMain && !isHotStyle && floor.type != '包表配楼层' && goodsNumCell == 2) {
                if (floor.title.indexOf('美妆') != -1 || floor.title.indexOf('配饰') != -1) {
                  floorItemBg = oldMainFloorBgs[0].blockBigBg
                } else if (floor.title.indexOf('服') != -1 || floor.title.indexOf('箱包') != -1) {
                  floorItemBg = oldMainFloorBgs[1].blockBigBg
                } else {
                  floorItemBg = oldMainFloorBgs[2].blockBigBg
                }
              }
              return (
                [
                  <div
                    className={`floor-item ${floor.type == '普通楼层' ? 'normal' : ''} ${isMain ? '' : 'fen-floor'} ${heightClassName}`}
                    key={`floor-item-${floorIndex}`}
                  >
                    <div
                      className="header-wrap"
                      style={{
                        background: `url(${utils.formatImgUrl(floor.bgHeaderImg, this.props.webpSupport)}) no-repeat`,
                        backgroundSize: "contain"
                      }}
                    >
                      <div className={floor.type == '包表配楼层' ? "header bbp" : 'header'}>
                        <div className="main-title">
                          <div className="title">{floor.title}</div>
                          <div 
                            className="nav"
                            onClick={() => {
                              // utils.handleItemClick(this.props.routeParams, floor.link, floor.type == '普通楼层' ? 'headstorey_branch' : 'middlestorey_branch', { from_sort: floorIndex, child_category_id: floor.cateIds, vertical_id: floor.breakCateId, from_floor: floor.title, line_total: goodsNumCell, from_floor_sort: floorIndex })
                              const options = {
                                sort: floorIndex
                              }
                              utils.jumpToUrl(this.props.routeParams,floor.link,floor.link,options,-1, this.props, false, {bizExtra: {model_block: 'more', floor_name: floor.tabName}});
                            }}>
                          </div>
                          <div className="sub-title">{floor.subTitle}</div>
                        </div>
                        {
                          isXxsFloor && goodsList.length > 0 &&
                          <div className="hot-list">
                            {
                              goodsList.slice(0, 3).map((item, index) => {
                                return (
                                  <div 
                                    className="hot-item"
                                    key={index}
                                    onClick={() => {
                                      // utils.handleItemClick(this.props.routeParams, item.url, 'middlestorey_explosive', { from_sort: index, child_category_id: floor.cateIds, vertical_id: floor.breakCateId, from_floor: floor.title, goods_id: item.goodsId, style_id: item.styleId, line_total: goodsNumCell, from_floor_sort: floorIndex })
                                      const options = {
                                        sort: index
                                      }
                                      utils.jumpToUrl(this.props.routeParams, item.url, item.url, options, -1, this.props, false);
                                    }}
                                  >
                                    <div className="hot-img">
                                      <LazyLoadImage
                                        width="100%"
                                        threshold={500}
                                        height="100%"
                                        src={utils.formatImgUrl(item.image, this.props.webpSupport)}
                                        effect="opacity"
                                      />
                                    </div>
                                    <div 
                                      className="hot-title"
                                      style={{
                                        backgroundColor: tagColor
                                      }}
                                    >
                                      ¥{item.price || '--'}
                                    </div>
                                  </div>
                                )
                              })
                            }
                          </div>
                        }
                      </div>
                      {
                        <div className={`footer footer-${floorIndex}`}>
                          <div className={`tag-list`}>
                            {
                              floor.keywordsList.length > 0 && floor.keywordsList.map((item, index) => {
                                return (
                                  <div 
                                    style={{ background: tagColor, borderColor: floor.tagBorderColor }} 
                                    className={isHotStyle ? "tag-item hot" : "tag-item" }
                                    key={index} 
                                    onClick={() => {
                                      // utils.handleItemClick(this.props.routeParams, `shihuo://www.shihuo.cn?route=homeSearchList&keywords=${encodeURIComponent(item)}&user_input=${encodeURIComponent(item)}`, isMain ? 'headstorey_dynamicLabels' : 'storey_dynamicLabels', { from_sort: index, tag_name: item, vertical_id: floor.breakCateId, from_floor: floor.title, line_total: goodsNumCell, from_floor_sort: floorIndex })
                                      const options = {
                                        sort: index
                                      }
                                      const url = `shihuo://www.shihuo.cn?route=homeSearchList&keywords=${encodeURIComponent(item)}&user_input=${encodeURIComponent(item)}`;
                                      utils.jumpToUrl(this.props.routeParams, url, url, options, -1, this.props, false, {bizExtra: {model_block: 'keywords', tabChName: item, floor_name: floor.tabName}});
                                    }}
                                  >
                                    {item}
                                  </div>
                                )
                              })
                            }
                            <div className="empty-item"></div>
                          </div>
                        </div>
                      }
                      {
                          <div className="collection-list">
                            {
                              floor.collectionList.length > 0 && floor.collectionList.slice(0, 2).map((list, listIndex) => {
                                return (
                                  <div className={`swiper-container collection-arr lottery-all-${floorIndex}-${listIndex} swiper-no-swiping`} key={listIndex}>
                                    <div className="swiper-wrapper">
                                    {
                                      list.map((item, index) => {
                                        return (
                                          <div
                                            style={{
                                              background: `url(${utils.formatImgUrl(collectionBg || 'https://static.shihuocdn.cn/admin/imgs/20211018/f75c4e2e94230d9f5f55a184d87bbb7b_325x102.png', this.props.webpSupport)}) center top no-repeat`
                                            }}
                                            className={`swiper-slide collection-item lottery-item-${listIndex}`} 
                                            key={index}
                                            onClick={() => {
                                              // utils.handleItemClick(this.props.routeParams, item.link, isMain ? 'headstorey_goodsset' : 'storey_goodsset', { from_sort: index, set_name: item.title, child_category_id: floor.cateIds, vertical_id: floor.breakCateId, from_floor: floor.title, line_total: goodsNumCell, from_floor_sort: floorIndex });
                                              const options = {
                                                sort: index
                                              }
                                              utils.jumpToUrl(this.props.routeParams, item.link, item.link, options, -1, this.props, false, {bizExtra: {model_block: 'collection', tabChName: item.title, floor_name: floor.tabName}});
                                            }}
                                          >
                                            {
                                              <div className="collection-img">
                                                <img src={utils.formatImgUrl(item.img, this.props.webpSupport)} alt="" />
                                                {/* <LazyLoadImage
                                                  width="100%"
                                                  threshold={500}
                                                  height="100%"
                                                  src={utils.formatImgUrl(item.img, this.props.webpSupport)}
                                                  effect="opacity"
                                                /> */}
                                              </div>
                                            }
                                            <div className="collection-title">{item.title}</div>
                                            <div className="collection-sub-title">{item.subTitle}</div>
                                          </div>
                                        )
                                      })
                                    }
                                    </div>
                                  </div>
                                )
                              })
                            }
                          </div>
                        }
                    </div>
                    {
                      (floor.collectionList.length >= 2 || goodsArr.length > 0) &&
                      <div
                        className={utils.isAndroid() ? "content android" : "content"} 
                        style={{
                          // backgroundImage: `url(${utils.formatImgUrl(floorItemBg, this.props.webpSupport)})`,
                          // backgroundRepeat: "no-repeat",
                          // backgroundSize: "100% 100%"
                        }}
                      >
                        <img src={floorItemBgSmall} alt="" className={floor.showPage == 1 ? "floor-item-bg-small show" : "floor-item-bg-small hide"} />
                        <img src={floorItemBgMiddle} alt="" className={floor.showPage == 2 ? "floor-item-bg-middle show" : "floor-item-bg-middle hide"} />
                        <img src={floorItemBgLarge} alt="" className={floor.showPage == 3 ? "floor-item-bg-large show" : "floor-item-bg-large hide"} />
                        {
                          goodsArr.length > 0 &&
                          <div className={`goods-block goods-block-${floorIndex}`}>
                            <div className={`goods-list`}>
                              {
                                goodsArr.map((arr, arrIndex) => {
                                  return (
                                    <div key={arrIndex} className="goods-arr-item">
                                      {
                                        arr.map((item, index) => {
                                          if (item.type == 'ad') {
                                            return (
                                              <div
                                                className="goods-ad"
                                                key={`${arrIndex}-${index}`}
                                                onClick={() => {
                                                  // utils.handleItemClick(this.props.routeParams, item.link, `goods_list_ad`, { from_sort: arrIndex * goodsNumCell + index, child_category_id: floor.cateIds, vertical_id: floor.breakCateId, goods_id: '', style_id: '', is_advertise: 1, from_floor: floor.title, line_total: goodsNumCell, from_floor_sort: floorIndex })
                                                  const options = {
                                                    sort: arrIndex * goodsNumCell + index
                                                  }
                                                  utils.jumpToUrl(this.props.routeParams, item.link, item.link, options, -1, this.props, false, {
                                                    bizExtra: {
                                                      model_block: 'goodsAd',
                                                      floor_name: floor.tabName,
                                                      goods_href: item.link,
                                                    }
                                                  });
                                                }}
                                              >
                                                <LazyLoadImage
                                                  width="100%"
                                                  threshold={500}
                                                  height="100%"
                                                  src={item.img}
                                                  effect="opacity"
                                                />
                                              </div>
                                            )
                                          }
                                          return (
                                            <div
                                              className="goods-item goods-item"
                                              key={`${arrIndex}-${index}`}
                                              onClick={() => {
                                                // utils.handleItemClick(this.props.routeParams, item.url, isMain ? `${floor.type == '普通楼层' ? 'headstorey' : 'middlestorey'}_goodslist` : 'storey_goods', { from_sort: arrIndex * goodsNumCell + index, child_category_id: floor.cateIds, vertical_id: floor.breakCateId, goods_id: item.goodsId, style_id: item.styleId, is_advertise: 0, from_floor: floor.title, line_total: goodsNumCell, from_floor_sort: floorIndex })
                                                const options = {
                                                  sort: arrIndex * goodsNumCell + index
                                                }
                                                utils.jumpToUrl(this.props.routeParams, item.url, item.url, options, -1, this.props, false, {
                                                  bizExtra: {
                                                    model_block: 'goods',
                                                    floor_name: floor.tabName,
                                                    goods_id: item.goodsId,
                                                    style_id: item.styleId
                                                  }
                                                });
                                              }}
                                            >
                                              <div className="goods-img">
                                                <LazyLoadImage
                                                  width="100%"
                                                  threshold={500}
                                                  height="100%"
                                                  src={utils.formatImgUrl(item.image, this.props.webpSupport)}
                                                  effect="opacity"
                                                />
                                              </div>
                                              {item.tag2 && <div className="top-tag"><div className={`tag-cont a${['识货补贴', '百亿补贴', '京东秒杀'].indexOf(item.tag2)}`}>{item.tag2}</div></div>}
                                              <div className="name" style={{ WebkitBoxOrient: "vertical" }}>{item.title}</div>
                                              <div className="price">
                                                <span className="cur-price"><span>¥</span>{item.price || '--'}</span>
                                                {item.original_price > 0 && <span className="origin-price">¥{item.original_price}</span>}
                                              </div>
                                              {/* {
                                                item.recommend &&
                                                <div className="tag-block">
                                                  <div className="tag">{item.recommend}</div>
                                                </div>
                                              } */}
                                            </div>
                                          )
                                        })
                                      }
                                    </div>
                                  )
                                })
                              }
                            </div>
                            {/* 展开更多 */}
                            {
                              floor.showPage < floor.pageSize && (
                                <div 
                                  className="fold-btn"
                                  onClick={() => {
                                    floor.showPage = floor.showPage + 1 > floor.pageSize ? 1 : floor.showPage + 1
                                    this.setState({});

                                    utils.uploadTrack(this.props, {}, {
                                      bizExtra: {
                                        model_block: 'expand',
                                        floor_name: floor.tabName
                                      }
                                    });
                                  }}
                                >
                                  {floor.showPage >= floor.pageSize ? '收起' : '展开'}
                                  <img 
                                    src={
                                      floor.showPage >= floor.pageSize
                                        ? 'https://static.shihuocdn.cn/admin/files/20220428/ae4dfe25d91e90343e93d55a384f68a0.png' 
                                        : 'https://static.shihuocdn.cn/admin/files/20220428/4f43946372964067d1206acec4518fe8.png'
                                    }
                                    alt=""
                                    className={floor.showPage >= floor.pageSize ? 'up' : 'down'}
                                  />
                                </div>
                              )
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>,
                  ztAdView
                ]
              )
            })
          }
        </div>
        {
          isMain && moreInfo.moreList.length > 0 && 
          <div
            className={`more-item`}
            style={{
              background: `url(${utils.formatImgUrl(moreFloorBg, this.props.webpSupport)}) center no-repeat`
            }}
          >
            <div className="list">
              {
                moreInfo.moreList.slice(0, 10).map((item, index) => {
                  return (
                    <div
                      className="item"
                      key={index}
                      style={{
                        background: `url(${utils.formatImgUrl(item.bgImg, this.props.webpSupport)}) center no-repeat`
                      }}
                      onClick={() => {
                        window.localStorage.setItem('last_click_tab_name', item.title)
                        // utils.handleItemClick(this.props.routeParams, item.link, 'tailstorey_more', { from_sort: index })
                        const options = {
                          sort: index
                        }
                        utils.jumpToUrl(this.props.routeParams, item.link, item.link, options, -1, this.props, false, {
                          bizExtra: {
                            model_block: "otherVenue",
                            tabChName: item.title
                          }
                        });
                      }}
                    >
                      <div className="img">
                        <LazyLoadImage
                          width="100%"
                          threshold={500}
                          height="100%"
                          src={utils.formatImgUrl(item.img, this.props.webpSupport)}
                          effect="opacity"
                        />
                      </div>
                      <div className="title">{item.title}</div>
                      <div className="sub-title">{item.subTitle}</div>
                    </div>
                  )
                })
              }
            </div>
          </div>
        }
      </div>
    );
  }
}

PipelineFloor.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineFloor };
export default PipelineFloor;



// WEBPACK FOOTER //
// ./components/pipeline-floor/index.js